import React from 'react';

const ImageGalleryStrip = ({ images }) => {
  return (
    <section className="section-padding">
      <div className="container">
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
          gap: '24px' 
        }}>
          {images.map((image, idx) => (
            <div key={image.id} style={{ overflow: 'hidden' }}>
              <img 
                src={image.src} 
                alt={`Gallery ${idx + 1}`}
                style={{ 
                  width: '100%', 
                  height: 'auto',
                  display: 'block',
                  transition: 'transform 0.5s ease'
                }}
                onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImageGalleryStrip;
